import { LogViewer } from '@vishwesh_5544/t2-logger-ui';
import { API_BASE_URL } from '../../services/api';

/**
 * Admin-only viewer for the backend's structured logs.
 *
 * LogViewer owns all of its own data fetching, filtering and pagination — it talks to the
 * log router mounted by the backend at /api/logs over plain fetch. It refetches on filter
 * change and on Refresh only; there is deliberately no polling.
 *
 * REACT_APP_API_URL already ends in `/api`, so the base is `${API_BASE_URL}/logs`.
 */
export default function Logs() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Logs</h1>
        <p className="text-sm text-gray-500 mt-1">
          Structured application logs from the backend, newest first.
        </p>
      </div>

      <LogViewer
        apiBaseUrl={`${API_BASE_URL}/logs`}
        // Function form, not a static object: it is called before every request, so a
        // rotated or refreshed token is always picked up.
        headers={() => ({ Authorization: `Bearer ${localStorage.getItem('token')}` })}
        pageSize={25}
      />
    </div>
  );
}
